<template>
    <div class="box">
        <div class="item">
            <div class="item-header"></div>
            <div class="rank-box">
                <rankBox v-model="rankList1Data" :header="headers1" @load="getRankList1"></rankBox>
            </div>
        </div>
        <div class="item">
            <div class="item-header header2"></div>
            <div class="rank-box">
                <rankBox v-model="rankList2Data"  @load="getRankList2" :header="headers2"></rankBox>
            </div>
        </div>
        <div class="item">
            <div class="item-header header3"></div>
            <div class="rank-box">
                <rankBox v-model="rankList3Data"  @load="getRankList3" :header="headers3"></rankBox>
            </div>
        </div>
    </div>
</template>
<script>
import rankBox from "../rank/index.vue";
import {request_get} from "../../utils/request.js";
export default {
    components:{
        rankBox
    },
    props:{
        cityInfo:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
        return {
            // 主体行业
            businessType:{
                1:"种植业",
                2:"畜牧业",
                3:"水产业",
                4:"其他行业",
                5:"加工业"
            },
            standard:{
                1:"绿色",
                2:"有机",
                3:"地理标志",
                4:"区域公用品牌",
                5:"名特优新"
            },
            currentCityInfo:{},
            rankList1:[],
            rankList2:[],
            rankList3:[],
            headers1:['编号','产品名称','主体名称','所属行业','种植标准','注册日期'],
            headers2:['编号','品牌名称','产品名称','所属行业','生产规模','年产量','所属地区','持证单位','获证时间'],
            headers3:['编号','品牌名称','产品名称','所属行业','所属地区','持证单位'],
            page1:0,
            page2:0,
            page3:0
        }
    },
    watch:{
        cityInfo:{
            handler(newVal){
                this.currentCityInfo = newVal;
                this.page1 = 0;
                this.page2 = 0;
                this.page3 = 0;
                this.rankList1 = [];
                this.rankList2 = [];
                this.rankList3 = [];
                this.getRankList1();
                this.getRankList2();
                this.getRankList3();
            },
            deep:true
        }
    },
    mounted(){
        this.currentCityInfo = this.cityInfo;
        this.getRankList1();
        this.getRankList2();
        this.getRankList3()
    },
    computed:{
        // 绿色有机
        rankList1Data(){
            return this.rankList1.map((ele,index) => {
                return {
                    values:[index+1,ele.name,ele.bodyName,this.businessType[+ele.business],this.standard[+ele.standard]||'暂无',ele.getDate]
                }
            })
        },
        rankList2Data(){
            return this.rankList2.map((ele,index) => {
                return {
                    values:[index+1,ele.brandName,ele.productName,this.businessType[+ele.industry],ele.productionScale,ele.attYearOutput,ele.area,ele.mainBodyName,ele.issueDate]
                }
            })
        },
        rankList3Data(){
            return this.rankList3.map((ele,index) => {
                return {
                    values:[index+1,ele.brandName,ele.name,this.businessType[+ele.business],ele.area,ele.bodyName]
                }
            })
        }
    },
    methods:{
        // 绿色有机农产品
        getRankList1() {
            this.page1++
            request_get("/lsd/product/lsyj",{area:this.currentCityInfo?.name,page:this.page1,pageSize:10},res => {
                if(res.code == 200) {
                    this.rankList1 = [...this.rankList1,...res.data.data]
                }
            })
        },
        // 产品地理标志
        getRankList2() {
            this.page2++
            request_get("/lsd/product/landmark",{area:this.currentCityInfo?.name,page:this.page2,pageSize:10},res => {
                if(res.code == 200) {
                    this.rankList2 = [...this.rankList2,...res.data.data]
                }
            })
        },
        getRankList3() {
            this.page3++
            request_get("/lsd/product/mtyx",{area:this.currentCityInfo?.name,page:this.page3++,pageSize:10},res => {
                if(res.code == 200) {
                    this.rankList3 = [...this.rankList3,...res.data.data]
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.box{
    display: flex;
    flex-direction: column;
    width:100%;
    height:100%;
    box-sizing: border-box;
    .item{
        width:100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        &:last-of-type{
            margin-bottom: 0;
        }
        .item-header{
            width:100%;
            height:50px;
            background: url("../../assets/imgs/base_right/lvse_youji.png") no-repeat;
            background-size:100% 100%;
        }
        .header2 {
            background: url("../../assets/imgs/base_right/dili.png") no-repeat !important;
            background-size:100% 100%;
        }
        .header3 {
            background: url("../../assets/imgs/base_right/mingte.png") no-repeat !important;
            background-size:100% 100%;
        }
        .rank-box{
            width:100%;
            height:240px;
        }
    }
}
</style>